module.exports = __webpack_public_path__ + "img/module-booking.a3042b3b.svg";